// ABOUTME: One field row of node-info: optional icon avatar, optional label, and the rendered value.
// ABOUTME: The dense variant removes the vertical padding of the row and of its text block.

import { Box, Stack, Typography } from '@ds/coolshop';
import { ReactNode } from 'react';

interface NodeInfoRowProps {
    // Text, or the label placeholder of the loading skeleton.
    label: ReactNode;
    icon?: ReactNode;
    showLabel: boolean;
    dense: boolean;
    children: ReactNode;
}

export function NodeInfoRow({ label, icon, showLabel, dense, children }: NodeInfoRowProps) {
    return (
        <Box display="flex" alignItems="center" gap={1.5} py={dense ? 0 : 1} overflowX="hidden">
            {icon && (
                <Box display="flex" alignItems="center" flexShrink={0}>
                    {icon}
                </Box>
            )}
            <Stack flex={1} minWidth={0} py={dense ? 0 : 0.5} gap={0}>
                {showLabel && (
                    <Typography variant="caption" color="text.secondary">
                        {label}
                    </Typography>
                )}
                <Box>{children}</Box>
            </Stack>
        </Box>
    );
}
